exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.StripeElement[data-v-0f15a4ce], .stripe-element-custom[data-v-0f15a4ce] {\n  box-sizing: border-box;\n  border: 1px solid #e4e4e4;\n  border-radius: 3px;\n  padding: 11px 0 11px 11px;\n}\n.StripeElement--focus[data-v-0f15a4ce] {\n  border-color: #a1a1a1;\n  box-shadow: 0 0 2px 2px #4d90fe;\n}\n.card-errors[data-v-0f15a4ce] {\n  color: #eb1c26;\n}\ndiv.field[data-v-0f15a4ce] {\n  background-color: #fff;\n}\ndiv.field.disabled[data-v-0f15a4ce] {\n  cursor: default;\n  background-color: #E9ECEF;\n}\n\n\n", ""]);

// exports
